import moment from "moment";
import utils from "../../core/src/utils";
import { authStore } from "@/stores/auth";

function currency(value) {
  if (value === null || value === undefined) return value;
  let authStoreVar = authStore();
  let countryCode = authStoreVar.locations?.[0]?.countryCode || "ES";
  return utils.currencyFilter(value, countryCode);
}

function applyFilters(app) {
  app.config.globalProperties.$filters = {
    dateTime(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm");
    },
    date(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    currency,
  };
  return app;
}

export { applyFilters, currency };
